<ng-container *ngIf="container; else noData">
  <dx-tab-panel
    [animationEnabled]="true"
    [swipeEnabled]="false"
    iconPosition="start"
    stylingMode="primary"
    width="100%">

    <dxi-item [title]="'Allgemein' | translate">
      <div *dxTemplate>
        <div class="inspect-content p-2">



          <div class="context-row">
            <div class="context-label">{{ 'Letzte Änderung' | translate }}</div>
            <div class="context-value">
              {{ container?.lastChanged ? (container.lastChanged | date:'short') : 'n/b' }}
            </div>
            <div class="context-actions">
              <dx-button stylingMode="text" hint="{{ 'Container bearbeiten' | translate }}" type="default" (onClick)="openContainerEdit()" icon="edit"></dx-button>
            </div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Lieferant' | translate }}</div>
            <div class="context-value">{{ dataSource?.name || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Typ' | translate }}</div>
            <div class="context-value">{{ dataSource?.type || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Letzter importierter Katalog' | translate }}</div>
            <div class="context-value">n/b</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Katalog-Anzahl' | translate }}</div>
            <div class="context-value">{{ container?.catalogIds?.length || 0 }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Produkt-Anzahl' | translate }}</div>
            <div class="context-value">{{ container?.productCount || 0 }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">🔴 {{ 'Gelöscht' | translate }}</div>
            <div class="context-value">0</div>
          </div>

          <div class="context-row">
            <div class="context-label">🟡 {{ 'Geändert' | translate }}</div>
            <div class="context-value">0</div>
          </div>

          <div class="context-row">
            <div class="context-label">🟢 {{ 'Neu' | translate }}</div>
            <div class="context-value">0</div>
          </div>

          <div class="context-row context-top">
            <div class="context-label">{{ 'Notizen' | translate }}</div>
            <div class="context-value context-pre">
              {{ container?.note || ('Kommentar hinzufügen…' | translate) }}
            </div>
          </div>

        </div>
      </div>
    </dxi-item>

    <dxi-item [title]="'Unternehmen' | translate">
      <div *dxTemplate>
        <div class="inspect-content p-2">
          <div class="logo-block"></div>

          <div class="context-row">
            <div class="context-label">{{ 'Name' | translate }}</div>
            <div class="context-value">{{ dataSource?.name || 'n/b' }}</div>

            <div class="context-actions">
              <dx-button stylingMode="text" hint="{{ 'Container bearbeiten' | translate }}" type="default" (onClick)="openContainerEdit()" icon="edit"></dx-button>
            </div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Typ' | translate }}</div>
            <div class="context-value">{{ dataSource?.type || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Kreditoren Nr' | translate }}</div>
            <div class="context-value">{{ dataSource?.kreditorNr || 'n/b' }}</div>
          </div>

          <div class="context-row context-wrap">
            <div class="context-label">{{ 'Alternative Namen' | translate }}</div>
            <div *ngIf="dataSource?.alternativeNames?.length; else noAltNames" class="context-value chips">
              <span *ngFor="let n of dataSource!.alternativeNames" class="chip">{{ n }}</span>
            </div>
            <ng-template #noAltNames><div class="context-value">n/b</div></ng-template>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Adresse' | translate }}</div>
            <div class="context-value">
              {{ dataSource?.address || 'n/b' }}
            </div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Website' | translate }}</div>
            <div class="context-value">{{ dataSource?.website || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Beschreibung' | translate }}</div>
            <div class="context-value">
              {{ dataSource?.description || 'n/b' }}
            </div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Weitere Marken' | translate }}</div>
            <div class="context-value">{{ dataSource?.brandName || 'n/b' }}</div>
          </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item [title]="'Weitere Infos' | translate">
      <div *dxTemplate>
        <div class="inspect-content p-2">
          <div class="section-title section-with-action">
            <span>{{ 'Informationen zum Produktsicherheitsgesetz' | translate }}</span>

            <dx-button stylingMode="text" hint="{{ 'Container bearbeiten' | translate }}" type="default" (onClick)="openContainerEdit()" icon="edit"></dx-button>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Ansprechpartner' | translate }}</div>
            <div class="context-value">{{ dataSource?.contactPerson || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Telefon' | translate }}</div>
            <div class="context-value">{{ dataSource?.supportTel || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'E-Mail' | translate }}</div>
            <div class="context-value">{{ dataSource?.supportMail || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Link zur Garantie / Produktsicherheit' | translate }}</div>
            <div class="context-value">{{ dataSource?.warrantyPages || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Support Website' | translate }}</div>
            <div class="context-value">{{ dataSource?.supportWebsite || 'n/b' }}</div>
          </div>

          <div class="section-title">{{ 'Zusatzinformationen' | translate }}</div>

          <div class="context-row">
            <div class="context-label">{{ 'Ansprechpartner' | translate }}</div>
            <div class="context-value">{{ dataSource?.salesContact || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Vertriebswebsite' | translate }}</div>
            <div class="context-value">{{ dataSource?.salesSupportWebsite || 'n/b' }}</div>
          </div>

          <div class="section-title">{{ 'Importeur Informationen' | translate }}</div>

          <div class="context-row">
            <div class="context-label">{{ 'Name' | translate }}</div>
            <div class="context-value">{{ dataSource?.importerName || 'n/b' }}</div>
          </div>

           <div class="context-row context-top">
            <div class="context-label">{{ 'Straße' | translate }}</div>
            <div class="context-value context-pre">{{ dataSource?.importerAddress.street || 'n/b' }}</div>
          </div>

          <div class="context-row context-top">
            <div class="context-label">{{ 'PLZ' | translate }}</div>
            <div class="context-value context-pre">
              {{ dataSource?.importerAddress.zip || 'n/b' }}
            </div>
          </div>

          <div class="context-row context-top">
            <div class="context-label">{{ 'Stadt' | translate }}</div>
            <div class="context-value context-pre">
              {{ dataSource?.importerAddress.state || 'n/b' }}
            </div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Website' | translate }}</div>
            <div class="context-value">{{ dataSource?.importerWebsite || 'n/b' }}</div>
          </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item title="SEO">
      <div *dxTemplate>
        <div class="inspect-content p-2">
          <p><b>SEO-Inhalte folgen …</b></p>
        </div>
      </div>
    </dxi-item>

  </dx-tab-panel>
</ng-container>

<ng-template #noData>
  <div class="p-3 text-muted">
    {{ 'Keine Container-Daten vorhanden.' | translate }}
  </div>
</ng-template>

<np-container-edit
  (onSaved)="onContainerSaved($event)"
  [(visible)]="editVisible"
  [container]="container"
  [editMode]="true">
</np-container-edit>
